var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defualt-box"},[_c('img',{staticClass:"defualt-img",attrs:{"src":require('@/assets/images/common/default_page/default_img_bg.png')}}),_vm._v(" "),_c('div',{staticClass:"defualt-title"},[_vm._v(_vm._s(_vm.mes))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f90220","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DefaultPage/index.vue
// module id = null
// module chunks = 